<template>
  <div class="user-report">

    <!-- START Search Box -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card shadow">
          <div class="card-body">
            <div class="row">
              <div class="col-xl-3 col-lg-6">
                <b-form-group class="ct-mb-margin-bottom-100" label-class="col-form-label"
                              label="조회 월" label-for="searchMonth"
                              label-cols="3" content-cols="9">
                  <date-picker id="searchMonth" v-model="searchForm.month"
                               type="month" value-type="YYYY-MM" append-to-body lang="ko"
                               :disabled-date="disabledAfterToday" @input="search" />
                </b-form-group>
              </div>
              <div class="col-xl-4 col-lg-6">
                <b-form-group label-class="form-check-label"
                              label="이용자 ID" label-for="searchUserId"
                              label-cols="3" content-cols="9">
                  <b-form-input id="searchUserId" type="text" placeholder="ex) 25551" v-model="searchForm.userId" @change="search" />
                </b-form-group>
              </div>
<!--              <search-buttons layout-class="col-lg-6 ct-margin-top-25"-->
<!--                              resetBtnClass="search-btn-reset" searchBtnClass="search-btn-search"-->
<!--                              :reset-fn="reset" :search-fn="search" />-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Search Box -->

    <!-- START Empty Template -->
    <template v-if="$_utils.isEmpty(result.info) || isEmptyMonthReport ">
      <div class="row">
        <div class="col-lg-12">
          <div class="card shadow">
            <div class="card-body">
              <div class="text-center ct-padding-top-100 ct-padding-bottom-100">
                <div class="row justify-content-center mt-5 mb-5">
                  <div class="col-sm-5">
                    <img src="@/assets/images/widget-img.png" class="img-fluid mx-auto d-block" />
                  </div>
                </div>
                <h4 class="text-uppercase mt-5 mb-5">
                  <div v-if="isEmptyMonthReport">
                    <span class="text-danger">{{ noDataRes.user }}</span> 님의 <span class="text-danger">{{ noDataRes.date }}</span> 데이터가 존재하지 않습니다.
                  </div>
                  <div v-else-if="this.$_utils.isEmpty(result.info)">
                    <span class="text-danger">이용자 ID</span>를 입력하여,<br class="d-inline-block d-sm-none"> 데이터를 조회 하세요.
                  </div>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- END Empty Template -->

    <!-- START Report Template -->
    <template v-else>
      <div class="row">
        <div class="col-lg-12">
          <div class="card shadow">
            <div class="card-body">

              <!-- START Report Title -->
              <div class="row mt-2 mb-2">
                <div class="col-lg-4">
                  <h4 class="text-deep-green ct-padding-left-50">
                    <span class="font-size-16 icon-padding-right">
                      <i class="mdi mdi-18px mdi-card-account-details-outline" />
                    </span>
<!--                    <span class="text-muted"> ID : </span>-->
                    {{ result.info.userId }}
                  </h4>
                </div>
                <div class="col-lg-8">
                  <div class="text-align-end">
                    <ul class="list-inline main-chart mb-0">
                      <li class="list-inline-item chart-border-left me-0 mb-2" :class="{'border-0':i === 0}"
                          v-for="(item, i) in reportInfo">
                        <h5>
                          <span class="font-size-13 icon-padding-right" :class="`text-${item.iconColor}`">
                            <i :class="`mdi ${item.icon}`" />
                          </span>
                          <span class="text-muted d-inline-block fw-normal font-size-14">{{ item.label }}</span>
                          <span class="main-value ms-3">{{ item.mainValue }}</span>
                          <span v-if="!$_utils.isEmpty(item.subValue)" class="sub-value ct-padding-left-50">
                            {{ item.subValue }}
                          </span>
                        </h5>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- END Report Title -->

              <hr class="separator separator--dotter" />

              <div class="row">
                <!-- START Left Zone -->
                <div class="col-lg-6">
                  <div class="card border-0">
                    <!-- START Info Box -->
                    <div class="row">
                      <div class="col-lg-4">
                        <small-info-count-to card-bg=""
                                             icon-image="mdi-battery-charging-medium" icon-color="primary"
                                             title="평균 충전량" value-title="kWh"
                                             :compared="!$_utils.isEmpty(result.info) ? result.info.avgTotEnergyVariation : 0"
                                             :end-val="!$_utils.isEmpty(result.info) ? result.info.avgTotEnergy : 0" />
                      </div>
                      <div class="col-lg-4">
                        <small-info-count-to card-bg=""
                                             icon-image="mdi-cash" icon-color="danger"
                                             title="평균 충전 요금" value-title="원"
                                             :compared="!$_utils.isEmpty(result.info) ? result.info.avgTotCostVariation : 0"
                                             :end-val="!$_utils.isEmpty(result.info) ? result.info.avgTotCost : 0" />
                      </div>
                      <div class="col-lg-4">
                        <small-info-count-to card-bg=""
                                             icon-image="mdi-currency-krw" icon-color="danger"
                                             title="평균 충전 단가" value-title="원"
                                             :compared="!$_utils.isEmpty(result.info) ? result.info.avgUnitPriceVariation : 0"
                                             :end-val="!$_utils.isEmpty(result.info) ? result.info.avgUnitPrice : 0" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-4">
                        <small-info-count-to card-bg=""
                                             icon-image="mdi-clock-time-three" icon-color="info"
                                             title="평균 충전 시간" value-title=""
                                             :compared="!$_utils.isEmpty(result.info) ? result.info.avgChargeTimeVariation : 0"
                                             :value-time="!$_utils.isEmpty(result.info) ? result.info.avgChargeTime : '-'" />
                      </div>
                      <div class="col-lg-4">
                        <small-info-count-to card-bg=""
                                             icon-image="mdi-calendar-clock" icon-color="success"
                                             title="예약 충전 건수" value-title="건"
                                             :compared="!$_utils.isEmpty(result.info) ? result.info.reservedCntVariation : 0"
                                             :end-val="!$_utils.isEmpty(result.info) ? result.info.reservedCnt : 0" />
                      </div>
                      <div class="col-lg-4">
                        <small-info-count-to card-bg=""
                                             icon-image="mdi-cash-plus" icon-color="danger"
                                             title="인센티브 금액" value-title="원"
                                             :compared="!$_utils.isEmpty(result.info) ? result.info.incentivePriceVariation : 0"
                                             :end-val="!$_utils.isEmpty(result.info) ? result.info.incentivePrice : 0" />
                      </div>
                    </div>
                    <!-- END Info Box -->

                    <!-- START List By Charge History -->
                    <div class="row mt-3">
                      <div class="col-lg-12">
                        <card-title icon-image="mdi-table-large" title="충전 이력" text-color="title" />
                        <div class="charge-history-table">
                          <b-table class="datatables text-nowrap"
                                   :fields="fields" :items="!$_utils.isEmpty(result.list) ? result.list : null">
                            <template #cell(chargeCnt)="data">
                              {{ $_utils.comma(data.item.chargeCnt) }}
                            </template>
                            <template #cell(totEnergy)="data">
                              {{ $_utils.comma(data.item.totEnergy) }}
                            </template>
                            <template #cell(totCost)="data">
                              {{ $_utils.comma(data.item.totCost) }}
                            </template>
                            <template #cell(reservedCnt)="data">
                              {{ $_utils.comma(data.item.reservedCnt) }}
                            </template>
                            <template #cell(incentivePrice)="data">
                              {{ $_utils.comma(data.item.incentivePrice) }}
                            </template>
                          </b-table>
                        </div>
                      </div>
                    </div>
                    <!-- END List By Charge History -->
                  </div>
                </div>
                <!-- END Left Zone -->

                <!-- START Right Zone -->
                <div class="col-lg-6">
                  <div class="card card-height-100">
                    <div class="card-body">

                      <!-- START Recommend Title Zone -->
                      <div class="row">
                        <div class="col-lg-7">
                          <h4 class="card-title mb-3">
                            <span class="icon-padding-right">
                              <i class="mdi mdi-car-hatchback ct-card-title" />
                            </span>
                            <span class="ct-card-title">
                              <span class="text-deep-green">{{ !$_utils.isEmpty(maxResult) ? maxResult.placeName : '-' }}</span>
                              충전기 이용 추천
                            </span>
                          </h4>
                        </div>
                        <div class="col-lg-5 text-align-end">
                          <span class="icon-padding-right">충전 단가</span>
                          <span class="font-size-18" id="price-tooltip">
                            <i class="mdi mdi-comment-question text-deep-green" />
                          </span>
                          <b-tooltip target="price-tooltip" placement="left">
                            <div class="py-1">
                              [봄,가을]<br/>
                              경부하 : 187.5 원 / kWh<br/>
                              중부하 : 199.7 원 / kWh<br/>
                              최대부하 : 199.7 원 / kWh<br/><br/>
                              [여름]<br/>
                              경부하 : 198.4 원 / kWh<br/>
                              중부하 : 244 원 / kWh<br/>
                              최대부하 : 244 원 / kWh<br/><br/>
                              [겨울]<br/>
                              경부하 : 209.3 원 / kWh<br/>
                              중부하 : 230.9 원 / kWh<br/>
                              최대부하 : 253.9 원 / kWh
                              <hr/>
                              급속 요금제<br/>
                              50kW : 324.4 원 / kWh<br/>
                              100kW이상 : 347.2 원 / kWh<br/><br/>
                              비회원<br/>
                              324.4 원 / kWh<br/>
                              전압에 따라 일부 상이
                            </div>
                          </b-tooltip>
                          <span class="ct-padding-left-100 icon-padding-right">추천 기준</span>
                          <span class="font-size-18 ct-padding-right-50" id="standard-tooltip">
                            <i class="mdi mdi-comment-question text-deep-green" />
                          </span>

                          <b-tooltip target="standard-tooltip" variant="primary" placement="left" class="w-50 tooltip-inner" custom-class="my-tooltip-class">
                            <div class="py-1 custom-tooltip">
                              [추천 조건]<br/>
                              1. 충전소의 충전기 3기 이상 설치 된곳<br/>
                              2. 회원, 로밍회원 대상 (비회원 제외)<br/>
                              3. 충전기별 1달간 충전기여도 70% 미만인 이용자<br/>
                                (충전기의 개인 이용건수 / 충전기의 전체 이용건수) * 100)<br/>
                              4. 충전기별 1달간 이용 이력에서 시간별, 요일별 2.5회 미만 이용자
                            </div>
                          </b-tooltip>

                        </div>
                      </div>
                      <!-- End Recommend Title Zone-->

                      <!-- Start Recommend Empty Template -->
                      <template v-if="$_utils.isEmpty(recommendResult)">
                        <div class="row justify-content-center m-5">
                          <div class="card-height-100 col-lg-12 ">
                              <div class="py-5 px-3 my-5">
                                <h4 class="text-center text-main-green font-size-16 lh-lg"> {{ !$_utils.isEmpty(result.info.userId) ? result.info.userId : '-' }}  이용자는<br/>
                                  지난달 충전 이력 분석 결과 추천기준에 해당하지 않아<br/>
                                  추천정보를 제공하지 않습니다.<br/>
                                </h4>
                              </div>
                          </div>
                        </div>
                      </template>
                      <!-- End Recommend Empty Template -->

                      <!-- Start Recommend Template -->
                      <template v-else>
                        <div class="mt-2 mb-3">
                          <table style="width: 100%; text-align: center">
                            <thead>
                            <tr>
                              <th>
                                <div class="bg-secondary-gradient" style="border-radius: 10px; margin: 5px 5px; padding: 8px 0;">
                                  <i class="mdi mdi-calendar" /> 요일 기준
                                </div>
                              </th>
                              <th>
                                <div class="bg-secondary-gradient" style="border-radius: 10px; margin: 5px 5px; padding: 8px 0;">선호 요일</div>
                              </th>
                              <th>
                                <div class="bg-secondary-gradient" style="border-radius: 10px; margin: 5px 5px; padding: 8px 0;">주요 충전 시간</div>
                              </th>
                              <th>
                                <div class="bg-primary-gradient" style="border-radius: 10px; margin: 5px 5px; padding: 8px 0;">추천 충전기</div>
                              </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, i) in recommendResult.base_on_day.recommend_evse">
                              <td style="width: 20%;">
                                <div class="bg-danger-gradient" style="border-radius: 10px; margin: 5px 5px; padding: 8px 0;">추천 Case {{ i+1 }}</div>
                              </td>
                              <td style="width: 25%;">
                                <div style="border: 1px solid #b8d8f8; border-radius: 10px; margin: 5px 5px; padding: 8px 0;">
                                  {{ item.day }}요일
                                </div>
                              </td>
                              <td style="width: 30%;">
                                <div style="border: 1px solid #b8d8f8; border-radius: 10px; margin: 5px 5px; padding: 8px 5px;">
                                  {{ (JSON.stringify(item.hour)).replace(/\[|\]/g, '') }}
                                </div>
                              </td>
                              <td style="width: 25%;">
                                <div style="border: 1px solid #b8d8f8; border-radius: 10px; margin: 5px 5px; padding: 8px 0;">
                                  {{ item.cso_evse_num }} (이용률 {{ item.utilization }}%)
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="mt-4">
                          <table style="width: 100%; text-align: center">
                            <thead>
                            <tr>
                              <th>
                                <div class="bg-secondary-gradient" style="border-radius: 10px; margin: 5px 5px; padding: 8px 0;">
                                  <i class="mdi mdi-history" /> 시간 기준
                                </div>
                              </th>
                              <th>
                                <div class="bg-secondary-gradient" style="border-radius: 10px; margin: 5px 5px; padding: 8px 0;">선호 시간</div>
                              </th>
                              <th>
                                <div class="bg-secondary-gradient" style="border-radius: 10px; margin: 5px 5px; padding: 8px 0;">주요 충전 요일</div>
                              </th>
                              <th>
                                <div class="bg-primary-gradient" style="border-radius: 10px; margin: 5px 5px; padding: 8px 0;">추천 충전기</div>
                              </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, i) in recommendResult.base_on_time.recommend_evse">
                              <td style="width: 20%;">
                                <div class="bg-danger-gradient" style="border-radius: 10px; margin: 5px 5px; padding: 8px 0;">추천 Case {{ i+1 }}</div>
                              </td>
                              <td style="width: 25%;">
                                <div style="border: 1px solid #b8d8f8; border-radius: 10px; margin: 5px 5px; padding: 8px 0;">
                                  {{ (JSON.stringify(item.hour)).replace(/\[|\]/g, '') }}
                                </div>
                              </td>
                              <td style="width: 30%;">
                                <div style="border: 1px solid #b8d8f8; border-radius: 10px; margin: 5px 5px; padding: 8px 0;">
                                  {{ item.day }}요일
                                </div>
                              </td>
                              <td style="width: 25%;">
                                <div style="border: 1px solid #b8d8f8; border-radius: 10px; margin: 5px 5px; padding: 8px 0;">
                                  {{ item.cso_evse_num }} (이용률 {{ item.utilization }}%)
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </template>
                      <!-- End Recommend Template -->

                    </div>
                  </div>
                </div>
                <!-- END Right Zone -->
              </div>

              <!-- START Bottom Zone -->
              <div class="row">
                <div class="col-lg-12">
                  <div class="card">
                    <div class="card-body">


                      <div class="row">
                        <div class="col-lg-6">
                          <div class="card border-0 px-3">
                            <div class="row justify-content-between">
                              <div class="col-8">
                                <card-title icon-image="mdi-chart-tree" title="충전 이용 패턴" text-color="title" />
                              </div>
                              <div class="col-4 text-end">
                                <span class="icon-padding-right">구간 기준</span>
                                <span class="font-size-18" id="heatmap-tooltip">
                                    <i class="mdi mdi-comment-question text-deep-green"/>
                                  </span>
                                <b-tooltip target="heatmap-tooltip" variant="primary" placement="left" custom-class="desc-tooltip">
                                  <div class="py-1">
                                    충전기 점유 시간대를<br/>
                                    요일과 시간으로 구분하여<br/>
                                    이용 분포도를 보기위한 차트로서,<br/>
                                    점유 시간 데이터를 5가지의 색상으로<br/>
                                    구분하여 시각화 합니다.<br/>
                                    (이용 건수의 최소, 최대값에 따라<br/>
                                    각 구간의 간격을 동일하게 나눔)
                                  </div>
                                </b-tooltip>
                              </div>
                            </div>

                            <div class="row border-bottom border-3 mx-1 mt-4 ct-margin-bottom-100 ct-padding-bottom-75">
                              <div class="col-lg-5">
                                <b-form-group class="ct-mb-margin-bottom-100 select-option" label-class="col-form-label"
                                              label="충전소" label-for="searchStationName"
                                              label-cols="2" content-cols="10">
                                  <multiselect id="searchStationName"
                                               v-model="searchForm.station" :options="stationOptions"
                                               label="text" placeholder="" select-label=""
                                               :allow-empty="false" deselect-label=""
                                               @input="searchCondition('evse')">
                                    <span slot="noResult">No Result</span>
                                  </multiselect>
                                </b-form-group>
                              </div>
                              <div class="col-lg-3">
                                <b-form-group class="ct-mb-margin-bottom-100 select-option" label-class="col-form-label"
                                              label="충전기" label-for="searchEvse"
                                              label-cols="2" label-cols-lg="4" content-cols="10" content-cols-lg="8">
                                  <multiselect id="searchEvse"
                                               v-model="searchForm.evse" :options="evseOptions"
                                               label="text" placeholder="" select-label=""
                                               :allow-empty="false" deselect-label=""
                                               @input="getEvseUsageItems()">
                                    <span slot="noResult">No Result</span>
                                  </multiselect>
                                </b-form-group>
                              </div>
                              <div class="col-lg-4">
                                <b-form-group class="text-align-end ct-mb-margin-bottom-100" label-class="form-check-label"
                                              label="" label-for="searchEvseType"
                                              label-cols="0" content-cols="12">
                                  <div id="searchEvseType" class="col-form-label">
                                    <div class="form-check form-check-inline" v-for="(evse, i) in usageOptions">
                                      <input class="form-check-input" type="radio" :id="`inlineRadio${i}`"
                                             :value="`${evse.value}`" v-model="searchForm.usage"
                                             @change="getEvseUsageItems()" />
                                      <label class="form-check-label" :for="`inlineRadio${i}`">{{ evse.name }}</label>
                                    </div>
                                  </div>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-lg-4 ct-mb-margin-bottom-100">
                                <info-mini-box box-bg="light"
                                               title-bg="primary-gradient" :title-width="40" title="충전소"
                                               value-color="black" :value-width="60"
                                               :value="`${$_utils.textLengthOverCut(!$_utils.isEmpty(maxResult) ? maxResult.placeName : '-', 7)}`"
                                               :title-value="`${!$_utils.isEmpty(maxResult) ? maxResult.placeName : '-'}`" />

                              </div>
                              <div class="col-lg-4 ct-mb-margin-bottom-100">
                                <info-mini-box box-bg="light"
                                               title-bg="primary-gradient" :title-width="40" title="최다 요일"
                                               value-color="black" :value-width="60"
                                               :value="`${!$_utils.isEmpty(maxResult) ? maxResult.maxUsedDay : '-'}`" />
                              </div>
                              <div class="col-lg-4">
                                <info-mini-box box-bg="light"
                                               title-bg="primary-gradient" :title-width="40" title="최다 시간"
                                               value-color="black" :value-width="60"
                                               :value="`${!$_utils.isEmpty(maxResult) ? maxResult.maxUsedHour : '-'}`" />
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-12">
                                <div id="chart-line" class="ct-chart-border mt-3" style="padding-bottom: 0px !important;">
                                  <apexchart ref="heatmap" type="heatmap" height="550"
                                             :options="chartHeatmapOptions" :series="chartHeatmapOptions.series" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6 pt-5 pt-lg-0">
                          <div class="card border-0 px-3">
                            <div class="row justify-content-between">
                              <div class="col-8">
                                <card-title icon-image="mdi-chart-bar" title="요일별 이용 충전기" text-color="title" />
                              </div>
                              <div class="col-4 text-end">
                                <span class="icon-padding-right">조회 기준</span>
                                <span class="font-size-18" id="day-guideline-tooltip">
                                    <i class="mdi mdi-comment-question text-deep-green"/>
                                  </span>
                                <b-tooltip target="day-guideline-tooltip" variant="primary" placement="left" custom-class="desc-tooltip">
                                  <div class="py-1">
                                    해당 차트는 <br/>
                                    충전 종료 시간 기준으로 집계된 차트로,<br/>
                                    '충전 이용 패턴' 차트에서 표시되는<br/>
                                    사용 시간이 다음 날로 이어질 경우<br/>
                                    종료된 날짜로 이용 건수가 집계 됩니다.
                                  </div>
                                </b-tooltip>
                              </div>
                            </div>
                            <div class="row mt-3 px-2">
                              <div class="col-lg-12 border-bottom border-3 mx-auto ct-margin-bottom-100 ct-padding-bottom-75 d-flex flex-wrap justify-content-between align-items-center">
                                <div v-for="(item, i) in dayButton"
                                     style="float: left; padding: 0.3em" :style="`width: ${item.width}`">
                                  <b-button pill :variant="searchForm.day === item.value ? 'info' : 'outline-info'"
                                            style="width:70px" @click="dayChange(item.value)">{{ item.label }}</b-button>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-4 ct-mb-margin-bottom-100">
                                <info-mini-box box-bg="light"
                                               title-bg="info-gradient" :title-width="50" title="최다 이용"
                                               value-color="black" :value-width="50"
                                               :value="`${!$_utils.isEmpty(dayResult) ? dayResult.data[searchForm.day].maxUsedCsoEvseNum : '-'}`" />
                              </div>
                              <div class="col-lg-4 ct-mb-margin-bottom-100">
                                <info-mini-box box-bg="light"
                                               title-bg="info-gradient" :title-width="50" title="최저 이용"
                                               value-color="black" :value-width="50"
                                               :value="`${!$_utils.isEmpty(dayResult) ? dayResult.data[searchForm.day].minUsedCsoEvseNum : '-'}`" />
                              </div>
                              <div class="col-lg-4">
                                <info-mini-box box-bg="light"
                                               title-bg="info-gradient" :title-width="50" title="나의 최다 이용"
                                               value-color="black" :value-width="50"
                                               :value="`${!$_utils.isEmpty(dayResult) ? dayResult.data[searchForm.day].myMaxUsedCsoEvseNum : '-'}`" />
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-12">
                                <div id="chart-line" class="ct-chart-border mt-3" style="padding-bottom: 0px !important;">
                                  <apexchart ref="chartByDay" type="bar" height="550"
                                             :options="chartByDayOptions" :series="chartByDayOptions.series" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- END Bottom Zone -->

            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- END Report Template -->

  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import smallInfoCountTo from '@/views/components/infoSmallCountTo.vue';
import cardTitle from '@/views/components/cardTitle.vue';
import infoMiniBox from '@/views/components/infoMiniBox.vue';
import EventBus from "@/views/layouts/event-bus";
import SearchButtons from "@/views/components/searchButtons.vue";

export default {
  components: { SearchButtons, Multiselect, smallInfoCountTo, cardTitle, infoMiniBox },
  data() {
    return {
      isEmptyMonthReport: false,
      searchForm: {
        month: moment().subtract(1,'months').format('YYYY-MM'),
        // userId: '1010010196157804',
        userId: null,
        station: null,
        evse: { 'value': 'all', 'text': '전체' },
        usage: 'me',
        day: 'DaySum'
      },
      result: {
        info: null,
        list: null
      },
      noDataRes: {
        user: null,
        date: null
      },
      reportInfo: [
        { label: '회원 유형', icon: 'mdi-office-building-marker-outline', mainValue: '-'},
        { label: '기간', icon: 'mdi-calendar-clock', mainValue: '-'}
      ],
      fields: [
        { key: 'placeName', label: '충전소' },
        { key: 'csoEvseNum', label: '충전기' },
        { key: 'chargeCnt', label: '이용 (건)', sortable: true },
        { key: 'totEnergy', label: '충전량 (kWh)', sortable: true },
        { key: 'totCost', label: '충전 금액 (원)', sortable: true },
        { key: 'reservedCnt', label: '예약 충전 (건)', sortable: true },
        { key: 'incentivePrice', label: '인센티브 (원)', sortable: true }
      ],
      stationOptions: [],
      evseOptions: [],
      usageOptions: [
        { value: 'all', name: '전체 이용' },
        { value: 'me', name: '나의 이용' }
      ],
      maxResult: null,
      chartHeatmapOptions: {
        chart: {
          toolbar: { show: false }
        },
        stroke: {
          width: 0
        },
        plotOptions: {
          heatmap: {
            radius: 0,
            enableShades: false,
            colorScale: {
              ranges: [
                  { from: 0, to: 0, name: '0건', color: '#B3E5FC' },
                  { from: 1, to: 3, name: '1건 ~ 3건', color: '#4FC3F7' },
                  { from: 4, to: 6, name: '4건 ~ 6건', color: '#03A9F4' },
                  { from: 7, to: 9, name: '7건 ~ 9건', color: '#0288D1' },
                  { from: 10, to: 200, name: '10건 이상', color: '#01579B' }
              ]
            }
          }
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ['#ffffff']
          }
        },
        xaxis: {
          type: 'category',
          categories: ['일', '월', '화', '수', '목', '금', '토'],
          position: 'bottom',
          labels: {
            style: {
              colors: '#000000',
              fontWeight: 'bold'
            }
          },
          tooltip: {
            enabled: false,
          }
        },
        title: {
          show: false,
          text: ''
        },
        legend: {
          position: 'bottom'
        },
        tooltip: {
          x: {
            show: true,
            formatter: val => `${val}요일`,
          },
          y: {
            formatter: val => `${val}건`,
            title: {
              formatter: val => `${val}시: `,
            }
          },
        },
        series: []
      },
      dayResult: null,
      dayButton: [
        { label: '일', value: '7', width: 12, widthClass: 'w-xs'},
        { label: '월', value: '1', width: 12, widthClass: 'w-xs'},
        { label: '화', value: '2', width: 12, widthClass: 'w-xs'},
        { label: '수', value: '3', width: 12, widthClass: 'w-xs'},
        { label: '목', value: '4', width: 12, widthClass: 'w-xs'},
        { label: '금', value: '5', width: 12, widthClass: 'w-xs'},
        { label: '토', value: '6', width: 12, widthClass: 'w-xs'},
        { label: '전체', value: 'DaySum', width: 16, widthClass: 'w-xs'},
      ],
      chartByDayOptions: {
        chart: {
          toolbar: { show: false }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          }
        },
        dataLabels: {
          enabled: false
        },
        colors: ['#4FC3F7', '#01579B'],
        stroke: {
          show: true,
          width: 2
        },
        xaxis: {
          categories: [],
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + ' 건'
            }
          }
        },
        series: []
      },
      recommendResult: null
    }
  },
  created() {
    EventBus.$on('go-to-user-report', (month, userId) => {
      const vm = this;

      vm.searchForm.month = month;
      vm.searchForm.userId = userId;
      vm.search();
    });
  },
  onBeforeUnmount() {
    EventBus.$off('go-to-user-report');
  },
  methods: {
    disabledAfterToday(date) {
      const today = new Date();

      return date > new Date(today.setMonth(today.getMonth()-1));
    },
    // reset() {
    //   const vm = this;
    //
    //   vm.searchForm.month = new Date(this.$moment('2023-01', 'YYYY-MM'));
    //   vm.searchForm.userId = '1010010196157804';
    // },
    search() {
      const vm = this;

      if (this.$_utils.isEmpty(vm.searchForm.userId)) {
        this.$swal('이용자 ID를 입력하세요.', '', 'warning');
        return false;
      }

      vm.getInfoItems();
      vm.getItems();
    },
    getInfoItems() {
      const vm = this;
      const _url = `/onmapi/stats/user-used/summary`;

      this.$axios.get(_url, {
        params: {
          targetMonth: vm.searchForm.month,
          userId: vm.searchForm.userId
        }
      }).then((res) => {
        if (!this.$_utils.isEmpty(res.data.items)) {
          vm.isEmptyMonthReport = false;
          vm.result.info = Object.assign({}, res.data.items);
          vm.reportInfo[0].mainValue = this.$_app.code.userType[res.data.items.userType];
          vm.reportInfo[1].mainValue = res.data.items.statsMonth;

          vm.$nextTick(() => {
            vm.searchCondition('place');
          })
        } else {
          vm.isEmptyMonthReport = true;
          vm.noDataRes.user = vm.searchForm.userId;
          vm.noDataRes.date = this.$moment(vm.searchForm.month).format('YYYY년 MM월');
          vm.dataReset();
        }
      }).catch((error) => {
        //this.$swal('이용자 리포트 Info 데이터 조회 실패', '', 'error');
        console.error(error)
      });
    },
    dataReset() {
      const vm = this;

      vm.result = {
        info: null,
        list: null
      };
      vm.reportInfo[0].mainValue = '-';
      vm.reportInfo[1].mainValue = '-';
    },
    getItems() {
      const vm = this;
      const _url = `/onmapi/stats/user-used/history`;

      this.$axios.get(_url, {
        params: {
          targetMonth: vm.searchForm.month,
          userId: vm.searchForm.userId
        }
      }).then((res) => {
        vm.result.list = res.data.items;
      }).catch((error) => {
        //this.$swal('충전 이력 데이터 조회 실패', '', 'error');
        console.error(error)
      });
    },
    searchCondition(val) {
      const vm = this;
      const _url = `/onmapi/stats/user-used/pattern-search/${val}`;

      this.$axios.get(_url, {
        params: {
          targetMonth: vm.searchForm.month,
          userId: vm.searchForm.userId,
          placeId: this.$_utils.isEmpty(vm.searchForm.station) ? null : vm.searchForm.station.value
        }
      }).then((res) => {
        if (val === 'place') {
          vm.stationOptions = res.data.items.places.map(item => ({
            value: item.placeId,
            text: item.placeName
          }));

          vm.searchForm.station = vm.stationOptions[0];
          vm.searchCondition('evse');
        } else if (val === 'evse') {
          vm.evseOptions = res.data.items.csoEvseNums.map(item => ({
            value: item.csoEvseNum,
            text: item.csoEvseNum
          }));
          vm.evseOptions.unshift({ 'value': 'all', 'text': '전체' });

          vm.getEvseUsageItems();
        }
      }).catch((error) => {
        //this.$swal('충전소 or 충전기 데이터 조회 실패', '', 'error');
        console.error(error)
      });
    },
    getEvseUsageItems() {
      const vm = this;

      vm.patternInfoItems();
      vm.getHeatmapChartItems();
      vm.getEvseByDayItems();
      vm.getRecommendItems();
    },
    patternInfoItems() {
      const vm = this;
      const _url = `/onmapi/stats/user-used/pattern-maxused`;

      this.$axios.get(_url, {
        params: {
          targetMonth: vm.searchForm.month,
          userId: vm.searchForm.usage === 'me' ? vm.searchForm.userId : vm.searchForm.usage,
          placeId: vm.searchForm.station.value
        }
      }).then((res) => {
        vm.maxResult = Object.assign({}, res.data);
      }).catch((error) => {
        //this.$swal('충전 이용 패턴 Info 데이터 조회 실패', '', 'error');
        console.error(error)
      });
    },
    getHeatmapChartItems() {
      const vm = this;
      const _url = `/onmapi/stats/user-used/pattern-chart`;

      this.$axios.get(_url, {
        params: {
          targetMonth: vm.searchForm.month,
          userId: vm.searchForm.usage === 'me' ? vm.searchForm.userId : vm.searchForm.usage,
          placeId: vm.searchForm.station.value,
          csoEvseNum: vm.searchForm.evse.value
        }
      }).then((res) => {

        const chartDataSeries = [];
        const useDataValues = [];

        res.data.items.forEach(item => {
          const hour = Object.keys(item)[0];
          const useCounts = Object.values(item)[0];

          chartDataSeries.push({
            name: hour,
            data: useCounts
          });
          useDataValues.push(...useCounts);
        });

        const minUsedata = Math.min(...useDataValues);
        const maxUsedata = Math.max(...useDataValues);

        if ((minUsedata > 10 && maxUsedata > 15) || (minUsedata <= 10 && maxUsedata > 15)) {

          const gap = Math.ceil((maxUsedata - minUsedata) / 5);
          vm.chartHeatmapOptions.plotOptions.heatmap.colorScale.ranges = [
            { from: minUsedata, to: minUsedata + gap, name: `0건 ~ ${minUsedata + gap}건`, color: '#bab3fc' },
            { from: minUsedata + gap + 1, to: minUsedata + gap * 2, name: `${minUsedata + gap + 1}건 ~ ${minUsedata + gap * 2}건`, color: '#9a91f5' },
            { from: minUsedata + gap * 2 + 1, to: minUsedata + gap * 3, name: `${minUsedata + gap * 2 + 1}건 ~ ${minUsedata + gap * 3}건`, color: '#7064e7' },
            { from: minUsedata + gap * 3 + 1, to: minUsedata + gap * 4, name: `${minUsedata + gap * 3 + 1}건 ~ ${minUsedata + gap * 4}건`, color: '#4b3fb7' },
            { from: minUsedata + gap * 4 + 1, to: maxUsedata, name: `${minUsedata + gap * 4 + 1}건 이상`, color: '#2d2281' }
          ]
        } else {
          vm.chartHeatmapOptions.plotOptions.heatmap.colorScale.ranges = [
            { from: 0, to: 0, name: '0건', color: '#B3E5FC' },
            { from: 1, to: 3, name: '1건 ~ 3건', color: '#4FC3F7' },
            { from: 4, to: 6, name: '4건 ~ 6건', color: '#03A9F4' },
            { from: 7, to: 9, name: '7건 ~ 9건', color: '#0288D1' },
            { from: 10, to: 200, name: '10건 이상', color: '#01579B' }
          ]
        }
        this.$refs.heatmap.updateOptions(vm.chartHeatmapOptions);
        this.$refs.heatmap.updateSeries(chartDataSeries);
      }).catch((error) => {
        //this.$swal('Heatmap Chart 데이터 조회 실패', '', 'error');
        console.error(error)
      });
    },
    getEvseByDayItems() {
      const vm = this;
      const _url = `/onmapi/stats/user-used/used-by-day`;

      this.$axios.get(_url, {
        params: {
          targetMonth: vm.searchForm.month,
          userId: vm.searchForm.userId,
          placeId: vm.searchForm.station.value
        }
      }).then((res) => {
        vm.dayResult = Object.assign({}, res.data.items);

        this.$refs.chartByDay.updateOptions({ xaxis: { categories: vm.dayResult.categories } });
        // this.$refs.chartByDay.updateSeries([
        //     {
        //       name: '타사용자 이용',
        //       data: vm.dayResult.data[vm.searchForm.day].otherCnt
        //     }, {
        //       name: '나의 이용',
        //       data: vm.dayResult.data[vm.searchForm.day].usedCnt
        //     }
        // ])
        vm.dayChange('DaySum')
      }).catch((error) => {
        //this.$swal('요일별 이용 차트 데이터 조회 실패', '', 'error');
        console.error(error)
      });
    },
    dayChange(val) {
      console.log(val)
      const vm = this;
      vm.searchForm.day = val;

      this.$refs.chartByDay.updateSeries([
        {
          name: '타사용자 이용',
          data: vm.dayResult.data[vm.searchForm.day].otherCnt
        }, {
          name: '나의 이용',
          data: vm.dayResult.data[vm.searchForm.day].usedCnt
        }
      ])
    },
    getRecommendItems() {
      const vm = this;
      const _url = `/onmapi/stats/user-used/recommend`;

      this.$axios.get(_url, {
        params: {
          targetMonth: vm.searchForm.month,
          userId: vm.searchForm.userId,
          placeId: vm.searchForm.station.value
        }
      }).then((res) => {
        if (!this.$_utils.isEmpty(res.data.items)) {
          vm.recommendResult = JSON.parse(res.data.items.recommendVal);
        } else {
          vm.recommendResult = null;
        }
      }).catch((error) => {
        //this.$swal('추천 정보 데이터 조회 실패', '', 'error');
        console.error(error)
      });
    }
  }
}
</script>
